import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingComponent } from './setting.component';
import {
  DocumentRowComponent,
  DocumentTemplateNewComponent,
  DocumentTemplateDetailComponent,
  DocumentTemplateListComponent,
  // DocumentTemplateComponent,
  MessageRowComponent,
  MessageTemplateNewComponent,
  MessageTemplateDetailComponent,
  MessageTemplateListComponent,
  // MessageTemplateComponent
  //FormBuilder
  CalculateInstanceComponent,
  GenericInstanceComponent,
  SelectInstanceComponent,
  GroupInstanceComponent,

  //Lookup data
  LookupDataDetailComponent,
  LookupDataListComponent,
  LookupDataRowComponent,
  //Lookup Type
  LookupTypeDetailComponent,
  LookupTypeListComponent,
  LookupTypeRowComponent,
  //Role
  RoleDetailComponent,
  RoleNewComponent,
  RoleListComponent,
  RoleRowComponent,
  RoleEditComponent,
  //User
  UserDetailComponent,
  UserListComponent,
  UserRowComponent,
  //App-config
  AppConfigDetailComponent,
  AppConfigListComponent,
  AppConfigRowComponent,
  //Procurement
  ProcurementDetailComponent,
  ProcurementListComponent,
  ProcurementRowComponent,
  //Company
  CompanyComponent,
  //Application
  ApplicationListComponent,
  ApplicationRowComponent,
  OrganizationTypeListComponent,
  OrganizationTypeRowComponent,

  //API
  ApiKeyListComponent,
  AccountSecurityComponent,
  MyProfileComponent,
  //Workflow
  WorkflowComponent,
  WorkflowRowComponent,
  WorkflowGroupsComponent,
  FAQComponent,
  FinancialYearEndComponent,
  FinancialYearListComponent,
  CompanyAffiliateTypesComponent,
  CompanyDataManagementComponent,
  AffiliateListComponent,
  ChatConfigurationComponent,
} from './components';
import { ApplicationSecurityComponent } from './components/application-security/application-security.component';
import { SecurityDashboardComponent } from './components/application-security/security-dashboard/security-dashboard.component';
import { SecurityIpManagementComponent } from './components/application-security/security-ip-management/security-ip-management.component';
import { SecurityFileUploadManagementComponent } from './components/application-security/security-file-upload-management/security-file-upload-management.component';
import { SecurityHomeComponent } from './components/application-security/security-home/security-home.component';
import { AlertManagementComponent } from './components/application-security/alerts/alerts.component';
import { AlertManagementDashboardComponent } from './components/application-security/alerts/alert-dashboard/alert-dashboard.component';
import { AlertNotificationsComponent } from './components/application-security/alerts/alert-notifications/alert-notifications.component';
import { AlertScenariosComponent } from './components/application-security/alerts/alert-scenarios/alert-scenarios.component';

import { UserManagementComponent } from './components/application-security/user-management/user-management.component';
import { AllUsersComponent } from './components/application-security/user-management/all-users/all-users.component';
import { BlockedUsersComponent } from './components/application-security/user-management/blocked-users/blocked-users.component';
import { RecentlyLoggedInUsersComponent } from './components/application-security/user-management/recently-logged-in-users/recently-logged-in-users.component';
import { GeofencingManagementComponent } from './components/application-security/geofencing-management/geofencing-management.component';
import { GeofenceDashboardComponent } from './components/application-security/geofencing-management/geofence-dashboard/geofence-dashboard.component';
import { GeofenceLogsComponent } from './components/application-security/geofencing-management/geofence-logs/geofence-logs.component';
import { GeofenceUserProfileSettingsComponent } from './components/application-security/geofencing-management/geofence-user-profile-settings/geofence-user-profile-settings.component';
import { GlobalGeofenceSettingsComponent } from './components/application-security/geofencing-management/global-geofence-settings/global-geofence-settings.component';
import { GeofenceUserComponent } from './components/application-security/geofencing-management/geofence-user/geofence-user.component';
import { DashboardGraphComponent } from './components/application-security/security-dashboard/dashboard-graph/dashboard-graph.component';
import { EventLogComponent } from './components/application-security/security-dashboard/event-log/event-log.component';
import { FileUploadDashboardComponent } from './components/application-security/security-file-upload-management/file-upload-dashboard/file-upload-dashboard.component';
import { FileLogsComponent } from './components/application-security/security-file-upload-management/file-logs/file-logs.component';
import { FileUploadSettingsComponent } from './components/application-security/security-file-upload-management/file-upload-settings/file-upload-settings.component';
import { ApplicationSecurityLogsComponent } from './components/application-security/logs/logs.component';
import { AllowedCountriesComponent } from './components/application-security/geofencing-management/global-geofence-settings/allowed-countries/allowed-countries.component';
import { DisallowedCompaniesComponent } from './components/application-security/geofencing-management/global-geofence-settings/disallowed-companies/disallowed-companies.component';
import { DynamicHeaderComponent } from './components/application-security/dynamic-header/dynamic-header.component';
import { RateLimitComponent } from './components/application-security/rate-limit/rate-limit.component';
import { RateLimitDashboardComponent } from './components/application-security/rate-limit/dashboard/rate-limit-dashboard.component';
import { RateLimitLogsComponent } from './components/application-security/rate-limit/rate-limit-logs/rate-limit-logs.component';
import { RateLimitProfileSettingsComponent } from './components/application-security/rate-limit/rate-limit-profile-settings/rate-limit-profile-settings.component';
import { GlobalRateLimitSettings } from './components/application-security/rate-limit/global-rate-limit-settings/global-rate-limit-settings.component';
import { UsersRateLimitProfileComponent } from './components/application-security/rate-limit/users-with-rate-limit-profile/users-with-rate-limit-profile.component';
import { SettingsHomeComponent } from './components/application-security/settings-home/settings-home.component';
import { SettingsListComponent } from './components/application-security/settings-home/settings-list/settings-list.component';

export const COMPONENTS: Array<any> = [
  DocumentRowComponent,
  DocumentTemplateNewComponent,
  DocumentTemplateDetailComponent,
  DocumentTemplateListComponent,
  // DocumentTemplateComponent,
  MessageRowComponent,
  MessageTemplateNewComponent,
  MessageTemplateDetailComponent,
  MessageTemplateListComponent,
  // MessageTemplateComponent
  //FormBuilder
  CalculateInstanceComponent,
  GenericInstanceComponent,
  SelectInstanceComponent,
  GroupInstanceComponent,

  //Lookup data
  LookupDataDetailComponent,
  LookupDataListComponent,
  LookupDataRowComponent,
  //Lookup Type
  LookupTypeDetailComponent,
  LookupTypeListComponent,
  LookupTypeRowComponent,
  //Role
  RoleDetailComponent,
  RoleNewComponent,
  RoleListComponent,
  RoleRowComponent,
  RoleEditComponent,
  //User
  UserDetailComponent,
  UserListComponent,
  UserRowComponent,
  //App-config
  AppConfigDetailComponent,
  AppConfigListComponent,
  AppConfigRowComponent,
  //Procurement
  ProcurementDetailComponent,
  ProcurementListComponent,
  ProcurementRowComponent,
  //Company
  CompanyComponent,
  //Application
  ApplicationListComponent,
  ApplicationRowComponent,
  OrganizationTypeListComponent,
  OrganizationTypeRowComponent,
  //API
  ApiKeyListComponent,
  AccountSecurityComponent,
  MyProfileComponent,
  //Workflow
  WorkflowComponent,
  WorkflowRowComponent,
  WorkflowGroupsComponent,
  FAQComponent,
  FinancialYearEndComponent,
  FinancialYearListComponent,
  CompanyAffiliateTypesComponent,
  CompanyDataManagementComponent,
  AffiliateListComponent,
  ChatConfigurationComponent,
];
const routes: Routes = [
  {
    path: '',
    data: { title: '' },
    component: SettingComponent,
  },
  {
    path: 'faq',
    data: { title: 'admin faq' },
    component: FAQComponent,
  },
  {
    path: 'company',
    data: { title: 'admin company' },
    component: CompanyComponent,
  },
  {
    path: 'application',
    data: { title: 'admin Applications Mgmt' },
    component: ApplicationListComponent,
  },
  {
    path: 'organization-type',
    data: { title: 'admin Organisation Type Mgmt' },
    component: OrganizationTypeListComponent,
  },
  {
    path: 'api-key',
    data: { title: 'admin api-key' },
    component: ApiKeyListComponent,
  },
  {
    path: 'my-profile',
    data: { title: 'admin my-profile' },
    component: MyProfileComponent,
  },
  {
    path: 'workflow',
    data: { title: 'admin workflow' },
    component: WorkflowComponent,
  },
  //   {
  //     path: 'workflow/:type/:id',
  //     component: WorkflowDetailComponent,
  //   },
  {
    path: 'account-security',
    data: { title: 'admin account-security' },
    component: AccountSecurityComponent,
  },
  {
    path: 'document-template',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin document-template list' },
        component: DocumentTemplateListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin document-template details' },
        component: DocumentTemplateDetailComponent,
      },
      {
        path: 'new',
        data: { title: 'admin document-template new' },
        component: DocumentTemplateNewComponent,
      },
    ],
  },
  {
    path: 'message-template',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin message-template list' },
        component: MessageTemplateListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin message-template details' },
        component: MessageTemplateDetailComponent,
      },
      {
        path: 'new',
        data: { title: 'admin message-template new' },
        component: MessageTemplateNewComponent,
      },
    ],
  },
  {
    path: 'workflow',
    data: { title: 'admin workflow' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin workflow list' },
        component: WorkflowComponent,
      },
      {
        path: ':id/detail',
        data: { title: 'admin workflow details' },
        component: WorkflowGroupsComponent,
      },
    ],
  },
  {
    path: 'lookup-category',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin lookup-category list' },
        component: LookupTypeListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin lookup-category details' },
        component: LookupDataListComponent,
      },
    ],
  },
  {
    path: 'app-config',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin app-config list' },
        component: AppConfigListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin app-config details' },
        component: AppConfigDetailComponent,
      },
    ],
  },
  {
    path: 'user',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin user list' },
        component: UserListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin user details' },
        component: UserDetailComponent,
      },
    ],
  },
  {
    path: 'role',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin role list' },
        component: RoleListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin role role details' },
        component: RoleDetailComponent,
      },
      {
        path: 'edit/:id',
        data: { title: 'admin role edit' },
        component: RoleEditComponent,
      },
      {
        path: 'new',
        data: { title: 'admin role new' },
        component: RoleNewComponent,
      },
    ],
  },
  {
    path: 'document-type',
    data: { title: '' },
    children: [
      {
        path: '',
        redirectTo: 'list',
      },
      {
        path: 'list',
        data: { title: 'admin document-type list' },
        component: ProcurementListComponent,
      },
      {
        path: 'detail/:id',
        data: { title: 'admin document-type details' },
        component: ProcurementDetailComponent,
      },
    ],
  },
  {
    path: 'company-affiliate-types',
    data: { title: 'admin company-tffiliate-types' },
    component: CompanyAffiliateTypesComponent,
  },
  {
    path: 'financial-year-end',
    data: { title: 'admin financial-eear-end' },
    component: FinancialYearEndComponent,
  },
  {
    path: 'company-data-management',
    data: { title: 'admin company-data-management' },
    component: CompanyDataManagementComponent,
  },
  {
    path: 'chat-config',
    component: ChatConfigurationComponent,
  },
  {
    path: 'application-security',
    data: { title: '' },
    component: ApplicationSecurityComponent,

    children: [
      {
        path: '',
        data: { title: 'Application Security' },
        component: SecurityHomeComponent,
      },
      {
        path: 'dashboard',
        data: { title: 'Dashboard' },
        component: SecurityDashboardComponent,
        children: [
          {
            path: '',
            redirectTo: 'graph',
          },
          {
            path: 'graph',
            data: { title: 'Graph' },
            component: DashboardGraphComponent,
          },
          {
            path: 'event-log',
            data: { title: 'Event Log' },
            component: EventLogComponent,
          },
        ],
      },
      {
        path: 'ip-management',
        data: { title: 'IP Management' },
        component: SecurityIpManagementComponent,
      },
      {
        path: 'file-upload',
        data: { title: 'File Upload Management' },
        component: SecurityFileUploadManagementComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
          },
          {
            path: 'dashboard',
            data: { title: 'Dashboard' },
            component: FileUploadDashboardComponent,
          },
          {
            path: 'logs',
            data: { title: 'File Logs' },
            component: FileLogsComponent,
          },
          {
            path: 'settings',
            data: { title: 'Settings' },
            component: FileUploadSettingsComponent,
          },
        ],
      },
      {
        path: 'user-management',
        data: { title: 'User Management' },
        component: UserManagementComponent,
        children: [
          {
            path: '',
            redirectTo: 'all-users',
            pathMatch: 'full',
          },
          {
            path: 'all-users',
            data: { title: 'all-Users' },
            component: AllUsersComponent,
          },
          {
            path: 'blocked-users',
            data: { title: 'Blocked-Users' },
            component: BlockedUsersComponent,
          },
          {
            path: 'recently-logged-in-users',
            data: { title: 'Recently-Logged-In-Users' },
            component: RecentlyLoggedInUsersComponent,
          },
        ],
      },
      {
        path: 'geofence-management',
        data: { title: 'Geofence Management' },
        component: GeofencingManagementComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            data: { title: 'Geofence Dashboard' },
            component: GeofenceDashboardComponent,
          },
          {
            path: 'logs',
            data: { title: 'Geofencing Logs' },
            component: GeofenceLogsComponent,
          },
          {
            path: 'user-profile-settings',
            data: { title: 'Geofencing User Profile Setting' },
            component: GeofenceUserProfileSettingsComponent,
          },
          {
            path: 'global-settings',
            data: { title: 'Geofence Global Settings ' },
            component: GlobalGeofenceSettingsComponent,
            children: [
              {
                path: '',
                redirectTo: 'allowed-countries',
                pathMatch: 'full',
              },
              {
                path: 'allowed-countries',
                data: { title: 'Allowed Countries' },
                component: AllowedCountriesComponent,
              },
              {
                path: 'disallowed-countries',
                data: { title: 'Disallowed Countries' },
                component: DisallowedCompaniesComponent,
              },
            ],
          },
          {
            path: 'users',
            data: { title: 'Geofence Users' },
            component: GeofenceUserComponent,
          },
        ],
      },
      {
        path: 'alerts',
        data: { title: ' Alerts Management' },
        component: AlertManagementComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            data: { title: ' Dashboard' },
            component: AlertManagementDashboardComponent,
          },
          {
            path: 'scenarios',
            data: { title: ' Scenarios' },
            component: AlertScenariosComponent,
          },
          {
            path: 'notifications',
            data: { title: ' Notifications' },
            component: AlertNotificationsComponent,
          },
        ],
      },
      {
        path: 'logs',
        data: { title: ' Logs' },
        component: ApplicationSecurityLogsComponent,
      },
      {
        path: 'dynamic-header',
        data: { title: 'Dynamic Header' },
        component: DynamicHeaderComponent,
      },
      {
        path: 'settings',
        data: { title: 'Settings' },
        component: SettingsHomeComponent,
        children: [
          {
            path: '',
            redirectTo: 'notifications',
            pathMatch: 'full',
          },
          {
            path: 'notifications',
            data: { title: 'Notification' },
            component: SettingsListComponent,
          },
        ],
      },

      {
        path: 'rate-limit',
        data: { title: ' Rate Limit' },
        component: RateLimitComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            data: { title: ' Dashboard' },
            component: RateLimitDashboardComponent,
          },
          {
            path: 'logs',
            data: { title: ' Logs' },
            component: RateLimitLogsComponent,
          },
          {
            path: 'profile-setting',
            data: { title: ' Profile Setting' },
            component: RateLimitProfileSettingsComponent,
          },
          {
            path: 'global-profile-setting',
            data: { title: ' Global Profile Setting' },
            component: GlobalRateLimitSettings,
          },
          {
            path: 'user-profile',
            data: { title: ' Users Rate Limit Profile' },
            component: UsersRateLimitProfileComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingRoutingModule {}
